export const CITY_CONFIG = "city-config"
export const GOOGLE_KEY = "AIzaSyAepRENixYzHWOOe9yUS2_VZ0P41ESD0wo";
export const AW_TRANSANCTION_TYPE="HBB_LEADS"
export const ENTERPRISE="ENTERPRISE"
export const AW_PAYMENT_MODE="HBB_AIRTIME"
export const AIRTIME="AIR_TIME"
export const SERVICE_TYPE="HBB_ODU_AW"
export const AM_PAYMENT_MODE="AIRTEL_MONEY"
export const FORM_SCHEMA=`cms/webpage/activePackage?opco=${process.env.REACT_APP_OPCO}&pageUrl=languagePrefix/get-form-schema`